export default __webpack_public_path__ + "static/media/avatar.13b8913e.png";